import { Map } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

const Header = () => {
  return (
    <header className="container mx-auto px-4 py-2 relative z-10">
      <div className="flex items-center gap-2">
        <button 
          onClick={() => window.location.href = '/'}
          className="flex items-center gap-2 hover:opacity-80 transition-opacity duration-200 cursor-pointer"
        >
          <div className="relative">
            <Map className="h-8 w-8 text-blue-600" />
            <div className="absolute -top-1 -right-1 w-3 h-3 bg-yellow-400 rounded-full animate-pulse"></div>
          </div>
          <span className="text-2xl font-bold text-slate-800">Carto</span>
        </button>
        <Badge variant="outline" className="ml-2 text-blue-600 border-blue-200 bg-blue-50 animate-pulse">
          AI COO for Small Business
        </Badge>
      </div>
    </header>
  );
};

export default Header;
